import { render, staticRenderFns } from "./EquipmentServicingScheduleDialog.vue?vue&type=template&id=b2c6b838&scoped=true&"
import script from "./EquipmentServicingScheduleDialog.vue?vue&type=script&lang=js&"
export * from "./EquipmentServicingScheduleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c6b838",
  null
  
)

export default component.exports